import { Cloudinary } from 'cloudinary-core'

const tifosyCloudinary = Cloudinary.new({ cloud_name: 'tifosy' })

export default tifosyCloudinary
